import {AxiosError} from "axios";

import {VEHICLE_CHECK_ERROR_CODES} from "./constants";

type RecognitionErrorBody = {
  error_code?: string;
  message?: string;
  retryable?: boolean;
  errors?: Record<string, string[] | string>;
  data?: {vehicle_check_id?: number};
};

export type ResumableCheckError = {
  checkId: number;
  errorCode: string;
  message: string;
  retryable: boolean;
};

function readCheckId(raw?: string[] | string): number | null {
  const value = Array.isArray(raw) ? raw[0] : raw;
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
}

/** Recognition failures still create a check, so UI can resume manually. */
export function extractResumableCheckId(error: unknown): ResumableCheckError | null {
  if (!(error instanceof AxiosError) || !error.response) {
    return null;
  }

  const body = error.response.data as RecognitionErrorBody;
  const code = body.error_code ?? "";
  const message = body.message ?? "Plate recognition failed";

  if (code === VEHICLE_CHECK_ERROR_CODES.unreadable || code === VEHICLE_CHECK_ERROR_CODES.unprocessable) {
    const checkId = readCheckId(body.errors?.vehicle_check_id);
    if (!checkId) return null;
    return {checkId, errorCode: code, message, retryable: false};
  }

  if (code === VEHICLE_CHECK_ERROR_CODES.aiUnavailable) {
    const checkId = Number(body.data?.vehicle_check_id);
    if (!Number.isFinite(checkId) || checkId <= 0) return null;
    return {checkId, errorCode: code, message, retryable: body.retryable ?? true};
  }

  return null;
}
